import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import cls from 'classnames';
import { noop } from 'lodash';
import { func } from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

import { getCustomerInfoDedup, updateBODStep } from 'actions/clz/0bod';
import LinearProgressBar from 'components/LinearProgressBar';
import { sendGAEvent } from 'utils/ga';

import history from '../../../../history';
import { STEPS, STEP_NAME, TIME_RECAL_API, TIME_WAITING } from '../constant';
import s from './style.css';

class WaitingDuplicated extends React.Component {
  static propTypes = {
    onVerifyDupUser: func,
    goToPage: func,
  };

  static defaultProps = {
    onVerifyDupUser: noop,
    goToPage: noop,
  };
  constructor(props) {
    super(props);
    this.state = {};
    this.interval = null;
    this.timeout = null;
  }

  componentDidMount() {
    this.interval = setInterval(() => {
      this.props.onVerifyDupUser();
    }, TIME_RECAL_API);

    this.timeout = setTimeout(() => {
      this.props.goToPage(STEPS.START_LOAN);
      history.push(`/${STEP_NAME[STEPS.START_LOAN]}`);
    }, TIME_WAITING);

    sendGAEvent('Visit_Page', 'Dedupe_Pending_Page', 'ACL_0BOD_Dedupe_Pending');
  }

  componentWillUnmount() {
    this.interval && clearInterval(this.interval);
    this.timeout && clearTimeout(this.timeout);
  }

  render() {
    return (
      <div className={s.container}>
        <div className={s.logoWrapper}>
          <img
            src="./../images/song-vui-3x.png"
            className={s.logo}
            alt="Sống vui cùng HomeCredit"
          />
        </div>
        <div className={s.imageWrapper}>
          <img
            className={s.image}
            src="./../images/duplicate.png"
            alt="Sống vui cùng HomeCredit"
          />
        </div>
        <div className={s.content}>
          <strong className={cls(s.congrate, s.noSpace)}>
            Đang kiểm tra lại hồ sơ của bạn
          </strong>
          <p className={s.waitingConfirm}>
            Vui lòng không đóng ứng dụng và chờ khoảng vài phút
          </p>
          <p className={s.waitingConfirm}>
            Đăng ký vay trực tuyến luôn tiện hơn phải chờ xét duyệt theo quy
            trình thủ công. Đừng vội đóng trình duyệt nhé!
          </p>
        </div>
        <hr className={s.dashed} />
        <div className={s.waitingResult}>
          ĐANG CHỜ KẾT QUẢ HỒ SƠ
          <div className={s.progressWrapper}>
            <LinearProgressBar />
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  onVerifyDupUser: () => {
    dispatch(getCustomerInfoDedup(true));
  },
  goToPage: step => {
    dispatch(updateBODStep(step));
  },
});

const enhance = compose(
  connect(
    null,
    mapDispatchToProps,
  ),
  withStyles(s),
);

export default enhance(WaitingDuplicated);
